(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["solution-preview-language-switcher"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('solution-language-switcher')) {
    class SolutionLanguageSwitcher extends HTMLElement {
      connectedCallback() {
        this.storageKey = this.dataset.storageKey;
        this.prompt = this.querySelector('[data-language-prompt]');

        this.querySelectorAll('[data-language-choice]').forEach((button) => {
          button.addEventListener('click', () => this.remember(`selected:${button.dataset.languageChoice}`));
        });

        this.querySelector('[data-language-dismiss]')?.addEventListener('click', () => {
          this.remember('dismissed');
          this.hidePrompt();
        });

        this.querySelector('[data-language-accept]')?.addEventListener('click', () => {
          this.remember('selected:ar');
          this.querySelector('[data-language-choice="ar"]')?.click();
        });

        if (this.dataset.enableSuggestion !== 'true' || this.dataset.currentLanguage === 'ar' || this.hasDecision()) return;

        const root = window.Shopify?.routes?.root || '/';
        const activeLanguage = window.Shopify?.language || this.dataset.currentLanguage;
        const query = new URLSearchParams({
          'language[enabled]': 'true',
          'language[exclude]': activeLanguage,
        });

        fetch(`${root}browsing_context_suggestions.json?${query}`, { credentials: 'same-origin' })
          .then((response) => {
            if (!response.ok) throw new Error('Localization suggestion unavailable');
            return response.json();
          })
          .then((data) => {
            const suggestion = data.suggestions?.find((entry) => entry.parts?.language)?.parts.language.handle;
            if (suggestion?.split('-')[0]?.toLowerCase() === 'ar' && !this.hasDecision()) this.showPrompt();
          })
          .catch(() => {});
      }

      hasDecision() {
        try {
          return Boolean(localStorage.getItem(this.storageKey));
        } catch (error) {
          return false;
        }
      }

      remember(value) {
        try {
          localStorage.setItem(this.storageKey, value);
        } catch (error) {}
      }

      showPrompt() {
        if (this.prompt) this.prompt.hidden = false;
      }

      hidePrompt() {
        if (this.prompt) this.prompt.hidden = true;
      }
    }

    customElements.define('solution-language-switcher', SolutionLanguageSwitcher);
  }
  } catch(e) { console.error(e); }
})();

})();
